export default __webpack_public_path__ + "icon_expand.e23f483393c5aa7b9bb0583110f9926a.svg";